import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

export function ProtectedRoute() {
  const { loading, token } = useAuth();
  const location = useLocation();
  if (loading) return <div className="splash"><div className="splash-orbit" /><p>Preparando tu LingoSound…</p></div>;
  if (!token) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}

export function ActivatedRoute() {
  const { loading, account } = useAuth();
  if (loading) return <div className="splash"><div className="splash-orbit" /><p>Verificando tu XR4…</p></div>;
  if (!account?.license || account.license.status !== "active") return <Navigate to="/activate" replace />;
  return <Outlet />;
}
